import React from "react";
import { useCancelBayHireRequest } from "@features/bay-hire/hooks/useBayHireMutations";
import { useTranslation } from "react-i18next";
import ReasonDialog from "./ReasonDialog";

interface CancelDialogProps {
  open: boolean;
  requestId: string;
  onClose: () => void;
  onSuccess: () => void | Promise<void>;
}

const CancelDialog: React.FC<CancelDialogProps> = ({ open, requestId, onClose, onSuccess }) => {
  const { t } = useTranslation();
  const cancelMutation = useCancelBayHireRequest();

  // DFT-0044 slice F (F3): attachmentId is optional evidence, uploaded and referenced by
  // ReasonDialog - never required to cancel.
  const handleSubmit = async (reason: string, attachmentId?: string) => {
    await cancelMutation.mutateAsync({ id: requestId, request: { reason, attachmentId } });
    await onSuccess();
  };

  return (
    <ReasonDialog
      open={open}
      title={t("bay-hire.cancel-dialog-title")}
      reasonLabel={t("bay-hire.cancel-reason-label")}
      submitLabel={t("bay-hire.cancel-request")}
      testIdPrefix="cancel"
      requestId={requestId}
      showAttachmentUpload
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  );
};

export default CancelDialog;
